import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ModalService } from '@lsq-frontend/common-ui';

@Component({
    selector: 'supplier-reset-enrollment-modal',

    template: `
        <p class="body" [style.marginBottom]="'2rem'">
            This contact will be directly responsible for enrolling the supplier into FastTrack.
            Changing the enrollment contact while enrollment is in progress will reset the
            supplier's enrollment state, invalidate the prior enrollment link, and mark the prior
            enrollment contact user as invalid. Please do not proceed unless you have verified a
            need for this change. This will not send out an enrollment invite automatically.
        </p>
        <form [formGroup]="formGroup">
            <lsq-label
                label="Supplier Contact Name*"
                [subLabel]="'The name of our primary contact for this supplier.'"
            ></lsq-label>
            <div class="row">
                <div class="col-12 col-lg-6">
                    <lsq-input
                        [placeholder]="'First Name'"
                        name="primaryContactFirstName"
                        formControlName="primaryContactFirstName"
                        [group]="formGroup"
                    >
                    </lsq-input>
                </div>
                <div class="col-12 col-lg-6">
                    <lsq-input
                        [placeholder]="'Last Name'"
                        name="primaryContactLastName"
                        formControlName="primaryContactLastName"
                        [group]="formGroup"
                    >
                    </lsq-input>
                </div>
            </div>
            <br />

            <lsq-label
                label="Supplier Contact Email Address*"
                [subLabel]="'The email where we can reach the primary contact.'"
            ></lsq-label>
            <lsq-input
                [placeholder]="'name@company.com'"
                name="primaryContactEmailAddress"
                formControlName="primaryContactEmailAddress"
                [group]="formGroup"
            >
            </lsq-input>
        </form>
    `
})
export class SupplierResetEnrollmenttModalComponent {
    public formGroup: FormGroup;

    constructor(private _modalService: ModalService) {
        this.formGroup = this._modalService.modal.data;
    }
}
